const COOKIES = {
  browserCookieId: 'BrowserCookieId',
  city: 'CVCurrentCity',
  dataDogSampling: '_dd_s',
  dismissedNccBanner: 'merch-dismissed-ncc-banner',
  dismissedNewPriceBanner: 'merch-dismissed-new-price-banner',
  dismissedWSYSBanner: 'merch-dismissed-wsys-banner',
  enableSearchExplainer: 'enable-search-explainer',
  featureBranchEnabled: 'carvana-merch-serenity-ui',
  featureBranchName: 'carvana-merch-serenity-ui-feature-name',
  idToken: 'CVIdToken',
  nativeAppCapabilities: 'X-CVNA-AppCapabilities-SRP',
  nativeAppVersion: 'X-CVNA-AppVersion',
  partnerId: 'CVActivePartnerId',
  removeFooter: 'srch-remove-footer',
  session: 'mdt-session-id',
  state: 'CVCurrentState',
  verboseLogging: 'merch-verbose-logging',
  zip: 'CVCurrentZip'
};

export default COOKIES;
